import { FC, useCallback, useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { WrappedFieldProps } from 'redux-form';
import { MuiClasses } from '../../../types';
import { withStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { FormLabel } from "@mui/material";
import FieldErrorTooltip from '../FieldErrorTooltip';
const styles = ({ breakpoints }: Theme) => ({
    error: {
        display: 'block',
        fontSize: '11px',
        color: 'red',
        margin: '0 0 4px 0',
        textAlign: 'left' as const,
        fontFamily: 'CircularRegular',
        'font-weight': '400',
        lineHeight: '1.66',
        letterSpacing: '0.03333em'
    },
    labelRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    placeholder: {
        position: 'absolute' as const,
        left: '75px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
        fontFamily: 'CircularRegular',
        fontSize: '13px',
        color: 'rgb(155, 155, 155)',
        fontWeight: 500,
        height: '40px',
        lineHeight: '40px',
    }
});
interface OwnProps {
    label: string;
    isError: boolean;
    placeholder: any;
    classes: MuiClasses;
    labelClassName?: string;
}
const ReduxPhoneField: FC<WrappedFieldProps & OwnProps> = ({ classes, input, meta: { error, submitFailed }, label, isError, placeholder, labelClassName }) => {
    const handleOnChange = useCallback((value: string, country: any) => {
        const dialCode: string = country?.dialCode || '';
        // "358 0401234567" → "358401234567": drop the national trunk zero instead of rejecting it
        const phone = dialCode && value.startsWith(`${dialCode}0`) ? `${dialCode}${value.slice(dialCode.length + 1)}` : value;
        input.onChange({
            phone,
            countryDialCode: dialCode
        });
    }, [input]);
    // Ensure value shape without mutating props directly
    // If an upstream passes a raw string value, normalize it once via onChange
    useEffect(() => {
        if (typeof input.value === 'string') {
            input.onChange({ phone: input.value });
        }
    }, [typeof input.value === 'string']); // eslint-disable-line react-hooks/exhaustive-deps
    const [isShown, setIsShown] = useState(true);
    const handleOnBlur = useCallback(() => {
        input.onBlur(input.value);
        setIsShown(true);
    }, [input]);
    const showError = isError && submitFailed && error !== undefined;
    return (<div style={{ position: 'relative', width: '100%' }}>
      <div className={classes.labelRow}>
        {label && (<FormLabel className={labelClassName}>{label}</FormLabel>)}
      </div>
      <div style={{ position: 'relative' }}>
        {isShown && input.value.phone?.length <= 3 ? (<div className={classes.placeholder}>{placeholder}</div>) : null}
        <PhoneInput specialLabel='' country='fi' value={input.value.phone} onChange={handleOnChange} placeholder={placeholder} onFocus={() => setIsShown(false)} onBlur={handleOnBlur} autoFormat={false} countryCodeEditable={false} inputProps={{ name: 'phone', autoComplete: 'tel', inputMode: 'tel' }}/>
      </div>
      <FieldErrorTooltip error={error} visible={showError} />
    </div>);
};
export default withStyles(styles as any)(ReduxPhoneField);
